<template>
  <div class="home">

      <Navbar/>

      <Hero
          :img="heroImg"
          intro="Not sure what you need or if we're the right fit?"
          title="Meet Us For a Coffee."
          below1="We love to talk about things we know."
          below2="And we love to hear about things we don’t."
          opacity="0.35"
      />


    <div class="container pt-6 px-3 sm:px-8 mx-auto m-0 pb-32 font-sans">

        <div class="flex flex-row flex-wrap">

            <div class="px-4 w-full md:w-1/2 pb-12">

                <p class="text-gray-200 pb-4">
                    We always make time to get out of the office for coffee meetings in Dublin every week.
                    You might want to sit down with Nick or Barry if you:
                </p>


                <ul class="text-gray-200 pb-4 pl-4 list-disc list-outside">
                    <li> Have an internet infrastructure project and you're not sure who can help.  </li>
                    <li> Want advice or feedback on an internet related product or project. </li>
                    <li> Feel like having a chat about anything network / internet related. </li>
                </ul>

                <p class="text-gray-200 pb-4">
                    If you decide to meet us for a coffee, we guarantee it won't come with a hard sell
                    and we'll always offer impartial advice.
                </p>

                <p class="text-gray-200 pb-4">
                    To arrange the coffee, drop us an email at <a class="border-b border-gray-500 border-dashed hover:border-b-0" href="mailto:hello@islandbridgenetworks.ie">hello@islandbridgenetworks.ie</a>.
                    Typically mornings between 1000 and 1200 work best but we'll find a slot that suits us all.
                </p>

                <p class="text-gray-200 pb-4">
                    Too far away for a quick coffee in Dublin? No problem, drop us an email and we'll set up a
                    coffee fueled call.
                </p>

            </div>

            <div class="px-4 w-full md:w-1/2 pb-12">

                <p class="text-gray-200 pb-4">
                    We like to meet in the Coffee House on Pearse Street. It's comfortable and not too loud.
                </p>

                <div class="p-4">
                    <iframe class="rounded-lg w-full" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.984766737854!2d-6.249176483628472!3d53.343528882622536!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e918045c88d%3A0xa204a701472bf55f!2sCoffee%20House!5e0!3m2!1sen!2sie!4v1570564511898!5m2!1sen!2sie"
                        frameborder="0" style="border:0; min-height: 250px;" allowfullscreen=""></iframe>
                </div>

            </div>

        </div>

    </div>


    <Footer/>

  </div>
</template>

<script>
import Hero     from '../components/Hero.vue'
import Footer   from '../components/Footer.vue'
import Navbar   from '../components/Navbar.vue'

export default {
  name: 'contact',
  beforeCreate: function() {
      document.body.className = 'bg-gray-800';
  },
  components: {
      Footer, Navbar,
      Hero,
  },
  data () {
    return {
        heroImg: require('@/assets/coffee-shop.jpg'),
    }
  }
}
</script>
